import moment from "moment";

export const getAgeFromBirthDate = (birthDate: Date | undefined): number => {
  if (!birthDate) return 0;
  return moment().diff(moment(birthDate), 'years');
};

/**
 * Format date as YYYY-MM-DD in local timezone.
 * Avoids UTC shift issues that occur with toISOString().
 */
export const formatDateLocal = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
